/**
 * A curated list of well-known "key" verses and short passages, used by the
 * toolbar's random-verse button. Each entry anchors on its first verse —
 * jumping there opens the full chapter around it and highlights that verse,
 * so the passage is always read in context rather than shown in isolation.
 * `endVerse` (when present) is informational only, describing how far the
 * passage runs; the anchor verse is what actually gets selected/highlighted.
 */
export const KEY_VERSES = [
	{ book: 'genesis', chapter: 1, verse: 1 },
	{ book: 'genesis', chapter: 1, verse: 27 },
	{ book: 'exodus', chapter: 3, verse: 14 },
	{ book: 'joshua', chapter: 1, verse: 9 },
	{ book: 'psalms', chapter: 23, verse: 1, endVerse: 6 },
	{ book: 'psalms', chapter: 46, verse: 10 },
	{ book: 'psalms', chapter: 100, verse: 1, endVerse: 5 },
	{ book: 'psalms', chapter: 119, verse: 105 },
	{ book: 'proverbs', chapter: 3, verse: 5, endVerse: 6 },
	{ book: 'isaiah', chapter: 40, verse: 31 },
	{ book: 'isaiah', chapter: 41, verse: 10 },
	{ book: 'isaiah', chapter: 53, verse: 5 },
	{ book: 'jeremiah', chapter: 29, verse: 11 },
	{ book: 'micah', chapter: 6, verse: 8 },
	{ book: 'matthew', chapter: 5, verse: 3, endVerse: 12 },
	{ book: 'matthew', chapter: 6, verse: 33 },
	{ book: 'matthew', chapter: 11, verse: 28 },
	{ book: 'matthew', chapter: 28, verse: 19, endVerse: 20 },
	{ book: 'mark', chapter: 12, verse: 30, endVerse: 31 },
	{ book: 'luke', chapter: 2, verse: 10, endVerse: 11 },
	{ book: 'john', chapter: 1, verse: 1 },
	{ book: 'john', chapter: 3, verse: 16 },
	{ book: 'john', chapter: 8, verse: 12 },
	{ book: 'john', chapter: 14, verse: 6 },
	{ book: 'john', chapter: 15, verse: 13 },
	{ book: 'acts', chapter: 1, verse: 8 },
	{ book: 'romans', chapter: 3, verse: 23 },
	{ book: 'romans', chapter: 5, verse: 8 },
	{ book: 'romans', chapter: 6, verse: 23 },
	{ book: 'romans', chapter: 8, verse: 28 },
	{ book: 'romans', chapter: 8, verse: 38, endVerse: 39 },
	{ book: 'romans', chapter: 10, verse: 9 },
	{ book: 'romans', chapter: 12, verse: 1, endVerse: 2 },
	{ book: '1-corinthians', chapter: 13, verse: 4, endVerse: 7 },
	{ book: '2-corinthians', chapter: 5, verse: 17 },
	{ book: 'galatians', chapter: 2, verse: 20 },
	{ book: 'galatians', chapter: 5, verse: 22, endVerse: 23 },
	{ book: 'ephesians', chapter: 2, verse: 8, endVerse: 9 },
	{ book: 'ephesians', chapter: 6, verse: 10, endVerse: 11 },
	{ book: 'philippians', chapter: 4, verse: 6, endVerse: 7 },
	{ book: 'philippians', chapter: 4, verse: 13 },
	{ book: 'colossians', chapter: 3, verse: 23 },
	{ book: '1-thessalonians', chapter: 5, verse: 16, endVerse: 18 },
	{ book: '2-timothy', chapter: 3, verse: 16 },
	{ book: 'hebrews', chapter: 11, verse: 1 },
	{ book: 'hebrews', chapter: 12, verse: 1, endVerse: 2 },
	{ book: 'james', chapter: 1, verse: 2, endVerse: 4 },
	{ book: '1-peter', chapter: 5, verse: 7 },
	{ book: '1-john', chapter: 1, verse: 9 },
	{ book: '1-john', chapter: 4, verse: 19 },
	{ book: 'revelation', chapter: 3, verse: 20 },
	{ book: 'revelation', chapter: 21, verse: 4 },
];
